
















































import { Component, Mixins, Prop, Ref, Vue } from "vue-property-decorator";
import VModal from "@/components/VModal.vue";
import CompanyPlace from "@/models/CompanyPlace";
import VGooglePlaceAutocomplete from "@/components/VGooglePlaceAutocomplete.vue";
import { currentCompanyStore, currentScoutingStore } from "@/store/typed";
import CompanyMixin from "@/mixins/http/CompanyMixin";
import Company, { CLIENT_TYPOLOGY, CompanyFilter } from "@/models/Company";
import AnalysisMixin from "@/mixins/http/AnalysisMixin";
import GenericCable from "@/cables/GenericCable";
import { Scouting } from "@/models";
import CompanyService from "@/service/CompanyService";
import VSelect from "@/components/VSelect.vue";
import VContentLoading from "@/components/VContentLoading.vue";

@Component({
  components: {
    VModal,
    VSelect,
    VContentLoading,
  },
})
export default class CreateAnalysisModal extends Mixins(AnalysisMixin) {
  @Prop({ default: "" }) readonly title?: string;
  @Ref() modal!: VModal;
  private cable: GenericCable | null = null;

  private analysisTitle = "";
  private scouting: Scouting | null = null;
  private companies: Company[] = [];
  private companiesOptions: any[] = [];
  private companySelected: Company | null = null;

  private isCreatingAnalysis = false;
  private errorMessage = "";

  async mounted() {
    this.isCreatingAnalysis = false;
    this.errorMessage = "";

    const filter = new CompanyFilter();
    filter.per = "all";
    this.companies = await CompanyService.getCompanies(filter);
    this.companiesOptions = this.companies
      .filter(
        (o) =>
          o.typology === CLIENT_TYPOLOGY.CLIENT ||
          o.typology === CLIENT_TYPOLOGY.PROSPECT
      )
      .map((o) => {
        return { id: o.id, text: o.name };
      });

    this.cable = new GenericCable("AnalysesChannel");
    this.cable.onResponse = this.onResponse;
    this.cable.open({ id: currentScoutingStore.scouting?.id });
  }

  protected onCancel() {
    this.modal.hide();
  }

  protected async onCreateAnalysis() {
    const parameters = {
      analysisName: this.analysisTitle,
      companyId: this.companySelected,
    };
    try {
      this.isCreatingAnalysis = true;
      this.scouting = await this.createAnalysis(parameters);
    } catch (e) {
      this.errorMessage = "Errore in fase di creazione analisi";
      this.isCreatingAnalysis = false;
    }
  }

  onResponse(data: any) {
    if (data.status === 200) {
      currentScoutingStore.resetScouting();
      this.$router.push({
        name: "company_analysis",
        params: {
          id: this.companySelected?.toString() || "",
          analysisId: this.scouting?.id || "",
        },
      });
    } else {
      this.errorMessage = "Errore in fase di creazione analisi";
      this.isCreatingAnalysis = false;
    }
  }

  show() {
    this.errorMessage = "";
    this.isCreatingAnalysis = false;
    this.modal.show();
  }

  onHidden() {
    this.modal.hide();
  }
}
